import type { Area } from "react-easy-crop"

/**
 * Crops an image to the specified pixel area and returns the result as a base64 data URL
 * @param imageSrc - The source URL of the image to crop (e.g., blob URL or data URL)
 * @param croppedAreaPixels - The pixel coordinates and dimensions of the crop area
 * @returns Promise<string> - A promise that resolves with the cropped image as a PNG data URL
 * @throws Error if the canvas 2D context cannot be obtained or the image fails to load
 */
export const cropImageToBlob = (imageSrc: string, croppedAreaPixels: Area): Promise<string> => {
	return new Promise((resolve, reject) => {
		const img = new Image()
		img.src = imageSrc

		img.onload = () => {
			const canvas = document.createElement("canvas")
			canvas.width = croppedAreaPixels.width
			canvas.height = croppedAreaPixels.height

			const ctx = canvas.getContext("2d")
			if (!ctx) return reject(new Error("Could not get canvas context"))

			ctx.drawImage(
				img,
				croppedAreaPixels.x,
				croppedAreaPixels.y,
				croppedAreaPixels.width,
				croppedAreaPixels.height,
				0,
				0,
				croppedAreaPixels.width,
				croppedAreaPixels.height,
			)

			resolve(canvas.toDataURL("image/png"))
		}

		img.onerror = reject
	})
}
